import undoable from 'redux-undo';

const DEFAULT_ITEM = {
  project_owner: '',
  // id: null,
  // sort: null,
  link: '',
  name: '',
  position: '',
  user_id: '',
};

const isValidState = (state: any) => {
  return Array.isArray(state) && state?.length;
};

function stakeholdersDataReducer(
  state: IOwnerList[] | undefined,
  action: IReducerAction<any>,
): IOwnerList[] {
  let result: IOwnerList[] | undefined = undefined;

  switch (action?.type) {
    case 'init':
      result = action?.payload?.data;
      break;

    case 'replace':
      result = action?.payload?.data;
      break;

    case 'add': {
      if (!isValidState(state)) break;
      const index = action?.payload?.index;
      if (typeof index === 'number') {
        const newState = state?.map((t) => ({...t})); // 这里不能改变原来的state，否则会影响undo redo
        newState?.splice(index + 1, 0, DEFAULT_ITEM);
        result = newState;
      }
      break;
    }

    case 'update': {
      if (!isValidState(state)) break;
      const index = action?.payload?.index,
            newItemList = action?.payload?.newItemList,
            isStudioModule = action?.payload?.isStudioModule;
      const newState = state?.map((t) => ({...t})); // 这里不能改变原来的state，否则会影响undo redo
      if (typeof index === 'number') {
        newState?.splice(index, 1, newItemList);
        result = newState;
      }
      break;
    }

    case 'delete': {
      if (!isValidState(state)) break;
      const index = action?.payload?.index;
      const newState = state?.map((t) => ({...t})); // 这里不能改变原来的state，否则会影响undo redo
      if (typeof index === 'number') {
        newState?.splice(index, 1);
        result = newState;
      }
      break;
    }
  
    default:
      result = [];
      break;
  }

  return result as IOwnerList[];
}

export default undoable(stakeholdersDataReducer, { /* limit: 3 */ });
